// Misc
import React, { createElement } from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Grow from '@material-ui/core/Grow'
import Chip from 'atoms/Chip'

// Icons
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'

// Styles
const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  content: {
    marginLeft: theme.spacing.unit * 3,
    borderLeft: '1px solid #E3E4E6',
    flex: 1,
  },
  icon: {
    lineHeight: 0
  }
})

const ExpandBase = ({ classes, onToggle, children, expanded, icon }) => (
  <div className={classes.root}>
    <Chip
      round
      disablePadding
      onClick={onToggle}
      icon={() => (
        <TransitionGroup exit={false} className={classes.icon}>
          <Grow key={expanded}>
            { expanded ? <CloseIcon /> : createElement(icon) }
          </Grow>
        </TransitionGroup>
      )}
    />
    <div className={classes.content}>
      { children }
    </div>
  </div>
)

ExpandBase.propTypes = {
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  icon: PropTypes.any,
  children: PropTypes.any,
}

ExpandBase.defaultProps = {
  icon: AddIcon,
}

export default withStyles(styles)(ExpandBase)
